import { capitalize } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import BackToTopIcon from '@material-ui/icons/VerticalAlignTop';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from 'fuse-ui/components/Typography';

import PropTypes from 'prop-types';

import ChangeDomainTypeButtonContainer from './table-action-buttons/change-domain-type-button-container';
import ClaimDomainAsButtonContainer from './table-action-buttons/claim-domain-as-button-container';
import DomainManagementOrgDomainMultiSelect from './domain-management-org-domain-multi-select';
import GroupDomainsButtonContainer from './table-action-buttons/group-domains-button-container';

import RemoveDomainsButtonContainer from
    './table-action-buttons/remove-domains-button-container';
import RemoveFromGroupButtonContainer from
    './table-action-buttons/remove-from-group-button-container';

import { translate } from '../../utils/translation-utils';

const styles = ( theme ) => {
    return {
        iconButton: {
            marginRight: `-${theme.spacing.unit}px`
        },
        leftAlignActions: {
            alignItems: 'center',
            display: 'flex'
        },
        rightAlignActions: {
            alignItems: 'center',
            display: 'flex'
        },
        tableOverview: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            padding: `${theme.spacing.unit / 2}px 0`,
        },
    };
};

export const DomainManagementTableActionsRow = ( {
    classes, count, handleScrollToTop, hasScrolled, orgDomainSelectData,
    handleOrgDomainMultiSelectFilter, selectedDomainFilter, selectedRows, type
} ) => {
    const formattedCount = count ? count.toLocaleString() : 0;
    const descriptor = selectedRows.length > 0 ?
        'Selected' :
        `${capitalize( type )} ${translate( selectedDomainFilter )}`;

    const claimedActionButtons = (
        <>
            <GroupDomainsButtonContainer selectedDomains={selectedRows} />
            <RemoveFromGroupButtonContainer selectedDomains={selectedRows} />
            <ChangeDomainTypeButtonContainer selectedDomains={selectedRows} />
            <RemoveDomainsButtonContainer
                selectedDomains={selectedRows}
                selectedDomainFilter={selectedDomainFilter}
                type={type}
            />
        </>
    );
    const discoveredActionButtons = (
        <>
            <ClaimDomainAsButtonContainer
                selectedDomains={selectedRows}
                selectedDomainFilter={selectedDomainFilter}
                type={type}
            />
            <RemoveDomainsButtonContainer
                selectedDomains={selectedRows}
                selectedDomainFilter={selectedDomainFilter}
                type={type}
            />
    </>
    );

    const buttonMap = {
        claimed: claimedActionButtons,
        discovered: discoveredActionButtons
    };

    return (
        <div className={classes.tableOverview}>
            <div className={classes.leftAlignActions}>
                <Typography>{formattedCount} {descriptor}</Typography>
                {
                    selectedRows.length > 0 && buttonMap[type]
                }
            </div>
            <div className={classes.rightAlignActions}>
                { orgDomainSelectData && handleOrgDomainMultiSelectFilter &&
                    ( <DomainManagementOrgDomainMultiSelect
                        orgDomainSelectData={orgDomainSelectData}
                        handleOrgDomainMultiSelectFilter={handleOrgDomainMultiSelectFilter}
                    /> )
                }
                <Tooltip title="Back to Top" placement="top">
                    {/* Need div to prevent console warning on tooltips wrapping disabled buttons */}
                    <div>
                        <IconButton
                            className={classes.iconButton}
                            data-automation-id="claimed-domains-back-to-top-button"
                            disabled={!hasScrolled}
                            onClick={() => handleScrollToTop( true )}
                        >
                            <BackToTopIcon />
                        </IconButton >
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};

DomainManagementTableActionsRow.defaultProps = {
    description: '',
    hasScrolled: false,
};

DomainManagementTableActionsRow.propTypes = {
    classes: PropTypes.object,
    count: PropTypes.number.isRequired,
    handleOrgDomainMultiSelectFilter: PropTypes.func,
    handleScrollToTop: PropTypes.func.isRequired,
    hasScrolled: PropTypes.bool.isRequired,
    orgDomainSelectData: PropTypes.array,
    selectedDomainFilter: PropTypes.string,
    selectedRows: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
};

export default withStyles( styles )( DomainManagementTableActionsRow );
